import { animated } from 'react-spring'

import styled, { css } from 'styled-components'

export const AnimatedContainer = styled(animated.div)`
  position: fixed;
  top: 0;
  left: auto;
  right: 0;
  bottom: 0;
  z-index: 10;
  height: 100dvh;
  width: max-content;
  margin: 0;
  padding: 0;
  border: none;
  will-change: transform;
  backface-visibility: hidden;
  transform: translateZ(0);
`

export const Container = styled.div`
  &[data-size='small'] {
    --minWidth: 25dvw;
    --width: 300px;
  }

  &[data-size='fluid'] {
    --minWidth: unset;
    --width: auto;
  }

  &[data-size='medium'] {
    --minWidth: 50dvw;
    --width: 600px;
  }

  &[data-size='large'] {
    --minWidth: 75dvw;
    --width: 1280px;
  }

  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100dvh;
    max-height: 100dvh;
    overflow: hidden;

    min-width: var(--minWidth);
    width: var(--width);
    max-width: 90dvw;

    box-shadow: ${theme.shadows.fromEnd.dp20}, ${theme.shadows.fromEnd.dp12};

    background: var(--white);
    color: var(--dark);
  `}
`

export const Title = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;

    padding: 1.5rem;

    z-index: 10;

    strong {
      flex: 1;
      font-size: ${theme.font.sizes.xlarge};
      font-weight: ${theme.font.semibold};
      line-height: 1.75rem;
      letter-spacing: -0.8px;
    }

    /* Botão de fechar: área clicável de 32x32 com o IconX do shoreline
       (svg de 20px com glifo de ~12.75px) centralizado — o IconButton tem
       paddings internos via --sl-element-space-*. */
    button[data-sl-icon-button] {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      padding: 0;
      border-radius: 0.5rem;

      svg {
        display: block;
      }
    }
  `}
`

export const Content = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: auto;

    ::-webkit-scrollbar {
      width: 0.5rem;
    }

    ::-webkit-scrollbar-track {
      background: ${theme.colors.inative};
      border-radius: 0.5rem;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.tertiary};
      transition: 0.3s ease-in-out all;
      border-radius: 0.5rem;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.gray};
    }
  `}
`

export const Overlay = styled(animated.button)`
  margin: auto;
  border: none;
  display: block;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;

  content: '';

  background-color: rgba(0, 0, 0, 0.65);
  z-index: 1;
`
